import React, { useState } from 'react';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../Nav/NavImages/logo.png'
import './Nav2.css';
// import NotificationsIcon from '@material-ui/icons/Notifications';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';


function Nav2() {
    const [click, setClick] = useState(false);
    const [navbar2, setNavbar2] = useState(false);

    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    const changeBackground = () => {
        if (window.scrollY >= 80) {
            setNavbar2(true)
        } else {
            setNavbar2(false)
        }
    }
    window.addEventListener('scroll', changeBackground);
    return (
        <Fragment>
            <nav className={navbar2 ? 'navbar2 active' : 'navbar2'}>
                <div className="navbar-container">
                    <Link to='/'
                        className="navbar-logo"
                        onClick={closeMobileMenu}>
                        <img src={Logo} alt="" width="80" height="80" />
                        <h6 className="nav-logo-txt">WeShare</h6>
                    </Link>
                </div>
                <div className="menu-icon" onClick={handleClick}>
                    <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
                </div>
                <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                    <li className="nav-item">
                        <Link to='/' className="nav-links" onClick={closeMobileMenu}>
                            Beranda
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to='/ayo-donasi' className="nav-links" onClick={closeMobileMenu}>
                            Ayo Donasi
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to='/buka-donasi' className="nav-links" onClick={closeMobileMenu}>
                            Buka Donasi
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to='/tentang-kami' className="nav-links" onClick={closeMobileMenu}>
                            Tentang Kami
                        </Link>
                    </li>
                </ul>
                <div className="nav2-icons">
                    <div className="notif">
                        {/* <NotificationsIcon /> */}
                    </div>
                    <div className="user">
                        <Link to="/user-dashboard">
                            <AccountCircleIcon />
                        </Link>
                    </div>
                </div>
            </nav>
        </Fragment >
    )
}

export default Nav2;